import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutGame } from './components/AboutGame';
import { Features } from './components/Features';
import { GameRules } from './components/GameRules';
import { MultiplayerSection } from './components/MultiplayerSection';
import { AppPreview } from './components/AppPreview';
import { WhyUs } from './components/WhyUs';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { HowToPlay } from './components/HowToPlay';

function HomePage() {
  return (
    <div className="antialiased text-white selection:bg-gradient-to-r selection:from-yellow-400 selection:to-yellow-600 selection:text-black min-h-screen">
      <Navbar />
      <Hero />
      <AboutGame />
      <Features />
      <GameRules />
      <MultiplayerSection />
      <AppPreview />
      <WhyUs />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/how-to-play" element={<HowToPlay />} />
      </Routes>
    </Router>
  );
}

export default App;
